export const ERROR_PAGE_ROUTES = {
    error: 'error',
    notFound: 'not-found',
    tooManyRequests: 'too-many-requests',
} as const;

export function isErrorPageUrl(url: string): boolean {
    const urlSegments = url.split(/[/?#;]/);
    return Object.values(ERROR_PAGE_ROUTES).some((route) => urlSegments.includes(route));
}

// Routed-only error page: kept out of the initial bundle (see AGENTS.md budget note).
export const loadErrorsComponent = () => import('./errors-component/errors.component').then((m) => m.ErrorsComponent);
